import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";

export const PaymentSettings_Fragment = graphqlShopifyStorefront(`
  fragment PaymentSettings on PaymentSettings {
    acceptedCardBrands  
    cardVaultUrl
    countryCode
    currencyCode
    enabledPresentmentCurrencies
    shopifyPaymentsAccountId
    supportedDigitalWallets
  }
`);
